import { withStyles } from "@material-ui/core/styles";
import React from "react";
import { FormLabel } from "@material-ui/core";
import classNames from "classnames";
const styles = (theme) => ({
  label: {
    color: "#263238",
    display: "block",
    fontWeight: "500",
    fontSize: "1rem",
    fontWeight: "500",
    lineHeight: "20px",
    letterSpacing: "-0.05px",
    marginBottom: "0.5rem",
  },
});
class LabelForm extends React.Component {
  render() {
    let { label = "", required = false, classes, customLabelForm } = this.props;
    return (
      <FormLabel
        required={required}
        className={classNames(classes.label, customLabelForm)}
      >
        {label}
      </FormLabel>
    );
  }
}

export default withStyles(styles)(LabelForm);
